import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import dayjs from 'dayjs';
import TransactionLink from "../../../TransactionLink";
import React from "react";
import {Type} from "../../../../redux/Transaction/helper";
import AmountTd, {AmountTdWidth} from "../../../Table/Common/AmountTd";

function getType(apiUrl) {
    switch (apiUrl) {
        case 'sst_recovered_payments':
            return Type.sale_payment;
        case 'sst_deemed_payments':
        default:
            return Type.tax_deemed_payment;
    }
}

// function getColClassName(columnType) {
//     switch (columnType) {
//         case 'category_total':
//             return 'report-category-total-col';
//         default:
//             return null;
//     }
// }

function getColumns(props) {
    const { apiUrl, companyCurrencySymbol } = props;

    return [
        {
            title: t`Date`,
            dataIndex: 'date',
            key: 'date',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => {
                switch (record.rowType) {
                    case 'total':
                        return t`TOTAL`;
                    default:
                        return (
                            <TransactionLink
                                transaction={{
                                    id: record.id,
                                    type: getType(apiUrl),
                                }}
                                label={dayjs(record.date).format('DD/MM/YYYY')}
                            />
                        );
                }
            },
        },
        {
            title: t`No.`,
            dataIndex: 'number',
            key: 'number',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => {
                switch (record.rowType) {
                    case 'total':
                        return null;
                    default:
                        return (
                            <TransactionLink
                                transaction={{
                                    id: record.id,
                                    type: getType(apiUrl),
                                }}
                                label={record.number || '-'}
                            />
                        );
                }
            },
        },
        {
            title: t`Invoice Date`,
            dataIndex: 'invoice_date',
            key: 'invoice_date',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => {
                if (!record.rowType)
                    return record.invoice_date ? dayjs(record.invoice_date).format('DD/MM/YYYY') : '-';
                return null;
            },
        },
        {
            title: t`Invoice No.`,
            dataIndex: 'invoice_number',
            key: 'invoice_number',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => {
                switch (record.rowType) {
                    case 'total':
                        return null;
                    default:
                        return (
                            <TransactionLink
                                transaction={{
                                    id: record.invoice_id,
                                    type: Type.sale_invoice,
                                }}
                                label={record.invoice_number || '-'}
                            />
                        );
                }
            },
        },
        {
            title: t`Invoice Description`,
            dataIndex: 'invoice_description',
            key: 'invoice_description',
            width: 0,
            flexGrow: 30,
            cellRenderer: ({ rowData: record }) => {
                if (record.rowType)
                    return null;
                return record.invoice_description || '-';
            },
        },
        {
            title: t`Amount`,
            dataIndex: 'invoice_base_amount',
            key: 'amount',
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: ({ rowData: record }) => (
                <AmountTd
                    currency_code={companyCurrencySymbol}
                    amount={record.invoice_base_amount}
                    style={{width: '100%'}}
                />
            ),
        },
    ];
}

export default {
    storageKey: StorageKey.report_sst_deemed_payments,
    getReportLabel: () => t`SST Deemed Payments`,
    required: [
        'date',
        'number',
        'amount',
    ],
    defaulto: [
        'invoice_date',
        'invoice_number',
        'invoice_description',
    ],
    getColumns,
};
